import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { releaseNotes } from '../../api/urls';
import { fetchGetFooterApi } from '../../api/FooterApi';
import './style.scss';
import { initElasticAPM } from '../../middlewares/applicationMonitoring/ElasticAPM';
import { initSessionHandler, stopSessionHandler } from '../../middlewares/sessionHandler';
import { NetworkDetector } from '../../middlewares/networkDetector';
import { withOktaAuth } from '@okta/okta-react';
import OpenReplay from '../../middlewares/applicationMonitoring/OpenReplay';
import { isEmpty } from '../../utils/helper';
import { EMPTY_OBJECT } from '../../constants/Constants';
import tapEvents, { HEADER_USER_FETCH } from '../../utils/tapEvents';
const Footer = props => {
  const [versionLink, setVersionLink] = useState('');
  const [userDetails, setUserDetails] = useState(null);
  useEffect(() => {
    const {
      apiBaseUrl,
      module,
      version
    } = props;

    // Initializing Elastic APM Real Time User Monitoring
    initElasticAPM({
      version
    });

    // Initializing Session Handler
    initSessionHandler(props.oktaAuth);
    const fetchData = async () => {
      const releaseNotesUrl = releaseNotes.replace('{module}', module).replace('{version}', version);
      const {
        data
      } = await fetchGetFooterApi("".concat(apiBaseUrl).concat(releaseNotesUrl));
      setVersionLink(data ? data.link : null);
    };
    fetchData();
    const onReceiveUserDetails = userDetails => {
      if (!isEmpty(userDetails)) {
        setUserDetails(userDetails);
      }
    };
    tapEvents.on(HEADER_USER_FETCH, onReceiveUserDetails);
    return () => {
      stopSessionHandler();
      tapEvents.off(HEADER_USER_FETCH, onReceiveUserDetails);
    };
  }, []);
  const {
    version,
    axiosInstance,
    openReplayMeta,
    openReplayOptions
  } = props;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "footer-container"
  }, /*#__PURE__*/React.createElement("p", null, "\xA9 ", __('Tekion Corp. 2024. All Rights Reserved.'))), /*#__PURE__*/React.createElement("div", {
    className: "version"
  }, versionLink ? /*#__PURE__*/React.createElement("a", {
    href: versionLink,
    rel: "noopener noreferrer",
    target: "_blank"
  }, __('Version'), ": ", version) : "Version: ".concat(version)), /*#__PURE__*/React.createElement(NetworkDetector, props), userDetails && /*#__PURE__*/React.createElement(OpenReplay, {
    axiosInstance: axiosInstance,
    userId: "".concat(userDetails.name, "_").concat(userDetails.email),
    metadata: openReplayMeta,
    openReplayOptions: openReplayOptions
  }));
};
Footer.propTypes = {
  apiBaseUrl: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
  module: PropTypes.string,
  axiosInstance: PropTypes.object,
  openReplayMeta: PropTypes.object,
  openReplayOptions: PropTypes.shape({
    tracker: PropTypes.object,
    trackerAxios: PropTypes.object,
    trackerAssist: PropTypes.object
  })
};
Footer.defaultProps = {
  module: 'TAP',
  axiosInstance: null,
  openReplayMeta: EMPTY_OBJECT,
  openReplayOptions: {
    tracker: EMPTY_OBJECT,
    trackerAxios: EMPTY_OBJECT,
    trackerAssist: EMPTY_OBJECT
  }
};
export default withOktaAuth(Footer);